import { MapResultsState, ResultsState } from '@immosky/types';
import { createSelector } from '@ngrx/store';
import { selectResultsState } from '../results.selectors';

export const selectMapResultsState = createSelector(
  selectResultsState,
  (resultsState: ResultsState) => resultsState.mapResults
);

export const selectMapResults = createSelector(
  selectMapResultsState,
  (state: MapResultsState) => state.results
);
